import React from "react";
import { NavLink } from "react-router-dom";

const InlineLink = ({ filter, navLinkClicked, style, className, children }) => (
  <NavLink
    // exact
    // to={filter === 'SHOW_ALL' ? '/' : `/${filter}`}
    to={`/${filter}`}
    // activeStyle={{
    //   textDecoration: "none",
    //   color: "black",
    // }}
    style={style}
    className={className}
    onClick={(e) => {
      // console.log("navlink clickedksld fl");
      if (typeof navLinkClicked === "function") {
        navLinkClicked();
      }
    }}
  >
    {children}
  </NavLink>
);

export default InlineLink;
